import React from "react";
import { Ticket } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "./ui/dialog";
import HelloAssoWidget from "./HelloAssoWidget";

export default function EventBookingButton({ url, label = "Réserver ma place", testid = "event-booking-btn" }) {
  const [open, setOpen] = React.useState(false);
  if (url.includes("/widget-bouton")) {
    return (
      <div data-testid="event-booking-widget">
        <HelloAssoWidget url={url} height={70} />
      </div>
    );
  }
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" data-testid={testid} className="btn-red rounded-full px-5 py-2.5 text-xs inline-flex items-center gap-2">
          <Ticket className="w-4 h-4" /> {label}
        </button>
      </DialogTrigger>
      <DialogContent data-testid={`${testid}-modal`} className="max-w-2xl w-[95vw] max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        <p className="he-overline text-neutral-500">Billetterie en ligne</p>
        <h2 className="font-heading text-xl font-bold tracking-tight -mt-2">Réservez votre place</h2>
        <HelloAssoWidget url={url} height={750} />
      </DialogContent>
    </Dialog>
  );
}
